import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Logger from '@/lib/Logger'

class Session {
  static data = {}

  static restore(json_data) {
    if (json_data) {
      Session.data = JSON.parse(json_data)
    } else {
      Session.data = {}
    }
    Logger.debug('Restored session:', Session.data)
  }

  static getWorkspaceId() {
    Logger.debug('getWorkspaceId => ', Session.data)
    if (Session.data?.workspaceId) {
      return Session.data.workspaceId
    } else {
      return Session.data?.personalWorkspaceId
    }
  }

  static async setWorkspaceId(workspaceId) {
    Logger.debug('setWorkspaceId ', workspaceId)
    Session.data.workspaceId = workspaceId
    // try {
    await this.save()
    // } catch (e) {
    // Logger.debug('Beccato')
    // }
  }

  static save() {
    Logger.debug('Session.save', Session.data)

    return GqlClient.runMutation({
      mutation: gql`
        mutation($json: String!) {
          sessionChange(jsondata: $json) {
            info
          }
        }
      `,
      variables: {
        json: JSON.stringify(Session.data),
      },
    })
  }

  static async clear() {
    Session.data = {}
    await this.save()
    Logger.debug('Cleared session')
  }
}

export default Session
